import { TableCell, TableHead, TableRow } from '@mui/material';

import { thStyle } from '@/ui/components/table/Table.utils';
import { translate } from '@/ui/i18n';

export function AddTourEventsTableHeader() {
  return (
    <TableHead>
      <TableRow>
        <TableCell style={thStyle} />
        <TableCell style={thStyle}>
          {translate('ProjectsTour.AddTourEventsModal.date')}
        </TableCell>
        <TableCell style={thStyle}>
          {translate('ProjectsTour.AddTourEventsModal.event-name')}
        </TableCell>
        <TableCell style={thStyle}>
          {translate('ProjectsTour.AddTourEventsModal.position')}
        </TableCell>
        <TableCell style={thStyle}>
          {translate('ProjectsTour.AddTourEventsModal.attendance')}
        </TableCell>
        <TableCell style={thStyle}>
          {translate('ProjectsTour.AddTourEventsModal.type')}
        </TableCell>
        <TableCell style={thStyle} />
      </TableRow>
    </TableHead>
  );
}
